export const FETCH_QUALIFY_STATUS = 'fetchQualifyStatus';
export const QUALIFY_STATUS_SUCCESS = 'qualifyStatusSuccess';
export const QUALIFY_STATUS_LOADING = 'qualifyStatusLoading';
export const QUALIFY_STATUS_ERROR = 'qualifyStatusError';
